import Reveal from "./Reveal";
import { journeySteps } from "@/config/professional";

export default function PatientJourney() {
  return (
    <section className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
              Como funciona
            </p>
            <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
              Seu cuidado começa pela escuta.
            </h2>
          </Reveal>
        </div>

        <ol className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-5">
          {journeySteps.map((step, i) => (
            <Reveal key={step.index} delay={i * 70}>
              <li className="group relative flex flex-col">
                <div className="flex items-center gap-3">
                  <span className="font-heading text-4xl font-medium text-primary-600/30 transition-colors duration-300 group-hover:text-primary-600/60">
                    {step.index}
                  </span>
                  {i < journeySteps.length - 1 && (
                    <span className="hidden h-px flex-1 bg-background-300 lg:block" />
                  )}
                </div>
                <h3 className="mt-4 font-heading text-xl font-semibold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {step.copy}
                </p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}